import { render, staticRenderFns } from "./RenderDetails.vue?vue&type=template&id=0fca218c&scoped=true&"
import script from "./RenderDetails.vue?vue&type=script&lang=js&"
export * from "./RenderDetails.vue?vue&type=script&lang=js&"
import style0 from "./RenderDetails.vue?vue&type=style&index=0&id=0fca218c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fca218c",
  null
  
)

export default component.exports